import styled from 'styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';

export const Tab = styled('div').withConfig({
  shouldForwardProp: interceptProps(['active']),
})<{
  active?: boolean;
}>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-bottom: 2px solid transparent;
  color: ${palette.textSecondary};
  font-weight: 500;
  cursor: pointer;
  ${({active}) =>
    active &&
    `
  color: ${palette.textPrimary};
  border-color: ${palette.gray800};
  font-weight: 700;
  `}
`;

export const Tabs = styled('div').withConfig({
  shouldForwardProp: interceptProps(['size']),
})<{
  size?: 'large' | 'medium';
}>`
  display: flex;
  ${({size = 'small'}) =>
    size === 'large'
      ? `height: 58px; font-size: 16px;`
      : `height: 42px; font-size: 14px;`}
`;
